console.log("WhatsApp Custom JS Loaded");

function updateWhatsappLink() {
    const component = document.querySelector("gty-whatsapp-chat-button");

    if (!component) {
        console.log("Component not found");
        return false;
    }

    const shadow = component.shadowRoot;

    if (!shadow) {
        console.log("Shadow root not found");
        return false;
    }

    const btn = shadow.querySelector(".gty-wacb-button");

    if (!btn) {
        console.log("Button not found");
        return false;
    }

    let message = "";

    // B2B page
    if (location.pathname.includes("b2b-coffee-solutions")) {
        message = "Hi, I am interested in knowing more about your business solutions";
    }
    // Product pages
    else if (location.pathname.startsWith("/products/")) {
        const title =
            document.querySelector("h1")?.innerText.trim() || document.title;

        const url = window.location.href;

        message = `Hi,

I'm interested in:

${title}

Product Link:
${url}`;
    } else {
        return true;
    }

    btn.href = `https://wa.me/919606774869?text=${encodeURIComponent(message)}`;

    console.log("Updated!", btn.href);

    return true;
}

// Try every 500ms until the button exists
const timer = setInterval(() => {
    if (updateWhatsappLink()) {
        clearInterval(timer);
    }
}, 500);